
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

import React, { useEffect, useRef } from 'react'
import moment from 'moment'
import itLocale from '@fullcalendar/core/locales/it';
import { HttpService } from '../../services/HttpService'
import { useSelector } from 'react-redux'

const FullCalendarTimeslot = (props: any) => {
  let inizialDate = props.inizialDate ?? null;
  let typeCalendar = props.typeCalendar ?? "";
  const categoryIds = props.categoryIds || [];
  const searchText = props.searchText || "";
  const fullCalendarId: any = useRef(null);

  useEffect(() => {
    if (fullCalendarId.current != null) {
      if (inizialDate != null) {
        let a = fullCalendarId.current.getApi();
        a.gotoDate(inizialDate)
      }

    }
  }, [inizialDate])

  /**
   * Fullcalendar event source function
   * https://fullcalendar.io/docs/events-function
   * Cannot be async... :(
   * @param fetchInfo fullcalendar info, contains the visualized range as start and end dates
   * @param successCallback pass events to visualize on calendar
   * @param failureCallback pass the error, dunno how it's used...
   */
  const loadEvents = (fetchInfo: any, successCallback: any, failureCallback: any) => {
    if (categoryIds.length === 0 && typeCalendar === "managerTimeslot") {
      return successCallback([]);
    }
    const queryParams = [
      `startDate=${fetchInfo.start.toISOString()}`,
      `endDate=${fetchInfo.end.toISOString()}`,
      ...categoryIds.map((c: any) => `categoryIds[]=${c}`),
      `search=${searchText}`,
    ];

    HttpService.get(
      `${process.env.REACT_APP_API}/${props.eventsSourceUrl}?${queryParams.join('&')}`
    ).then(response => {
      successCallback(response.data);
    }).catch(error => {
      failureCallback(error);
    });
  };

  return (
    <div className="CalendarTimeslot">
      <FullCalendar
        ref={fullCalendarId}
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="timeGridWeek"
        eventClick={props?.eventClick}
        dateClick={props?.dateClick}
        firstDay={1}
        locales={[itLocale]}
        events={loadEvents}
        headerToolbar={{
          left: 'title,prev,next,today',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        }}
        locale={'it'}
        eventContent={(arg) => {
          let startTimeslot = moment(arg.event.start?.getTime()).format("HH:mm")

          let textPlaces = "";
          if (arg.event._def.extendedProps.maximumAttendances) {
            textPlaces = arg.event._def.extendedProps.savedAttendances + "/" + arg.event._def.extendedProps.maximumAttendances
          }
          let italicEl = document.createElement('div')
          if (typeCalendar !== "attendancesList") {
            if (arg.event.extendedProps.deleted) {
              italicEl.innerHTML = '<div class="labelTimeslot opacity" style="background-color:' + arg.backgroundColor + '"><span class="material-symbols-outlined">lock</span><p>' + textPlaces + " " + startTimeslot + ' ' + arg.event.title + '</p></div>';
            }
            else if (arg.event.extendedProps.hideAgenda) {
              italicEl.innerHTML = '<div class="labelTimeslot opacity" style="background-color:' + arg.backgroundColor + '"><span class="material-symbols-outlined">visibility_off</span><p>' + textPlaces + " " + startTimeslot + ' ' + arg.event.title + '</p></div>';
            }
            else if (arg.event._def.extendedProps.savedAttendances === arg.event._def.extendedProps.maximumAttendances) {
              italicEl.innerHTML = '<div class="labelTimeslot " style="background-color:' + arg.backgroundColor + '"><span class="iconTypo"><span class="pointer"></span></span><p>' + textPlaces + " " + startTimeslot + ' ' + arg.event.title + '</p></div>';
            } else {
              italicEl.innerHTML = '<div class="labelTimeslot active" style="background-color:' + arg.backgroundColor + '"><span class="iconTypo"><span class="pointer"></span></span><p>' + textPlaces + " " + startTimeslot + ' ' + arg.event.title + '</p></div>';
            }
          }
          else {
            let endTimeslot = moment(arg.event.end?.getTime()).format("HH:mm")
            italicEl.innerHTML = '<div class="labelTimeslot" style="background-color:' + arg.backgroundColor + '"><p>' + startTimeslot + ' / ' + endTimeslot + ' - ' + arg.event.title + '</p></div>';
          }

          let arrayOfDomNodes = [italicEl]
          return { domNodes: arrayOfDomNodes }
        }}
      />
    </div>
  )

}
export default FullCalendarTimeslot;